import { HttpInterceptorFn } from '@angular/common/http';
import { DevToolService } from './dev-tool.service';
import { inject } from '@angular/core';
import { ENV } from '@core/env.token';

export const devModeInterceptor: HttpInterceptorFn = (req, next) => {
  const devMode = inject(DevToolService);
  const environment = inject(ENV);

  if (!environment.production && devMode.isImpersonating()) {
    req = req.clone({
      headers: req.headers.set('X-DevMode-Override-UserId', devMode.getUserId() ?? ''),
    });
  }

  return next(req);
};
